import './App.scss';
import '@measured/puck/puck.css';
import { CheckoutRouter } from './router/checkout-router';
import { Toaster } from 'shared-components';
import { persistor, store } from 'redux-setup/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <CheckoutRouter />
          <Toaster />
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
